module.exports = __webpack_public_path__ + "assets/images/feedback_e152f761acd0197577440f9b6725d0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-ten/feedback.png
// module id = 252
// module chunks = 0